<template>
  <div id="top">
    <ContentHeader class="content" />
    <v-layout row>
      <v-col cols="1"></v-col>
      <v-col cols="10">
    <h2 class="title justify-center">{{info['specie']}}</h2>
    </v-col><v-col cols="1"></v-col></v-layout>
    <div v-if="this.$vuetify.breakpoint.mdAndUp">
      <v-layout row><v-col cols="1"></v-col>
      <v-col cols="10">
        <div class="justify-center">
      <PhotoInfo
        :orde="info['orde']"
        :familie="info['familie']"
        :lengte_van="info['lengte_van']"
        :lengte_tot="info['lengte_tot']"
        :omschrijving="info['omschrijving']"
        :phone="false"
        class="test"
      /></div>
      </v-col><v-col cols="1"></v-col>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row><v-col cols="1"></v-col>
      <v-col cols="10">
      <PhotoInfo
        :orde="info['orde']"
        :familie="info['familie']"
        :lengte_van="info['lengte_van']"
        :lengte_tot="info['lengte_tot']"
        :omschrijving="info['omschrijving']"
        :phone="true"
        class="test_phone justify-center"
      />
      </v-col><v-col cols="1"></v-col>
      </v-layout>
    </div>
    <div class="navigation" v-if="this.$vuetify.breakpoint.mdAndUp">
      <div class="photos_viewphotos_div">
        <v-layout>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in sortedKeys[0]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {id: item}}">
                
                <v-img contain class="photo" :src="sortedSpecies[0][item]"><p class="link">{{sortedSpecies[0][item]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in sortedKeys[1]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {id: item}}">
                <v-img contain class="photo" :src="sortedSpecies[1][item]"><p class="">{{sortedSpecies[0][item]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
          <v-col class="columns mt-5 view_photo" cols="4">
            <div v-for="(item) in sortedKeys[2]" :key="item.id">
              <router-link :to="{ name: 'Carousel', params: {id: item}}">
                <v-img contain class="photo" :src="sortedSpecies[2][item]"><p class="">{{sortedSpecies[0][item]}}</p></v-img>
              </router-link>
            </div>
          </v-col>
        </v-layout>
        <Footer class="footer_photos mt-12" />
      </div>
    </div>
    <div v-else class="main-div-phone">
      <v-layout>
        <v-col cols="1"></v-col>
        <v-col class="columns mt-5 view_photo" cols="10">   
          <div v-for="(item) in sortedKeysPhone" :key="item.id">           
            <router-link :to="{ name: 'Carousel', params: {id: item}}">
              <v-img contain class="photo-phone" :src="sortedSpeciesPhone[item]"><p class="">{{sortedSpecies[0][item]}}</p></v-img>
            </router-link>
          </div>
        </v-col>
      </v-layout>
      <Footer class="footer_photos mt-12" />
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
import PhotoInfo from "../components/PhotoInfo";
export default {
  name: "ViewPhotos",
  data() {
    return {
      species: this.$route.params.species,
      lang: this.$route.params.lang
    };
  },
  components: {
    ContentHeader,
    Footer,
    PhotoInfo
  },
  computed: {
    info() {
      var res = {};
      for (var i = 0; i < Object.keys(this.specie).length; i++) {
        if (this.lang == "nl") {
          if (
            this.specie[Object.keys(this.specie)[i]]["soort_nederlands"] ==
              this.species ||
            this.specie[Object.keys(this.specie)[i]]["soort_engels"] ==
              this.species
          ) {
            res["orde"] = this.specie[Object.keys(this.specie)[i]]["orde"];
            res["familie"] = this.specie[Object.keys(this.specie)[i]][
              "familie"
            ];
            res["lengte_van"] = this.specie[Object.keys(this.specie)[i]][
              "lengte_van"
            ];
            res["lengte_tot"] = this.specie[Object.keys(this.specie)[i]][
              "lengte_tot"
            ];
            res["omschrijving"] = this.specie[Object.keys(this.specie)[i]][
              "omschrijving"
            ];
            res["specie"] = this.specie[Object.keys(this.specie)[i]][
              "soort_nederlands"
            ];
          }
        } else {
          if (
            this.specie[Object.keys(this.specie)[i]]["soort_nederlands"] ==
              this.species ||
            this.specie[Object.keys(this.specie)[i]]["soort_engels"] ==
              this.species
          ) {
            res["orde"] = this.specie[Object.keys(this.specie)[i]][
              "orde_engels"
            ];
            res["familie"] = this.specie[Object.keys(this.specie)[i]][
              "familie_engels"
            ];
            res["lengte_van"] = this.specie[Object.keys(this.specie)[i]][
              "lengte_van"
            ];
            res["lengte_tot"] = this.specie[Object.keys(this.specie)[i]][
              "lengte_tot"
            ];
            res["omschrijving"] = this.specie[Object.keys(this.specie)[i]][
              "omschrijving_engels"
            ];
            res["specie"] = this.specie[Object.keys(this.specie)[i]][
              "soort_engels"
            ];
          }
        }
      }
      return res;
    },
    photos() {
      return this.$store.state.photos;
    },
    specie() {
      var sp = this.$store.state.specie;
      var res = {};
      for (var i = 0; i < sp.length; i++) {
        res[sp[i]["id"]] = sp[i];
      }
      console.log(res);
      return res;
    },
    selectedSpecies() {
      var e = {};
      for (var i = 0; i < this.photos.length; i++) {
        if (
          this.specie[this.photos[i]["specie"]]["soort_nederlands"] ==
            this.species ||
          this.specie[this.photos[i]["specie"]]["soort_engels"] == this.species
        ) {
          e[this.photos[i]["id"]] = this.photos[i]["image"];
        }
      }
      return e;
    },
    sortedTemp() {
      return Object.keys(this.selectedSpecies)
        .sort()
        .reverse();
    },
    sortedKeys() {
      var e1 = Object.keys(this.sortedSpecies[0])
        .sort()
        .reverse();
      var e2 = Object.keys(this.sortedSpecies[1])
        .sort()
        .reverse();
      var e3 = Object.keys(this.sortedSpecies[2])
        .sort()
        .reverse();
      return [e1, e2, e3];
    },
    sortedKeysPhone() {
      return Object.keys(this.sortedSpeciesPhone);
    },
    sortedSpecies() {
      var e1 = {};
      var e2 = {};
      var e3 = {};
      var index = 1;
      for (var i = 0; i < this.sortedTemp.length; i++) {
        if (index == 1) {
          e1[this.sortedTemp[i]] = this.selectedSpecies[this.sortedTemp[i]];
          index = 2;
        } else if (index == 2) {
          e2[this.sortedTemp[i]] = this.selectedSpecies[this.sortedTemp[i]];
          index = 3;
        } else {
          e3[this.sortedTemp[i]] = this.selectedSpecies[this.sortedTemp[i]];
          index = 1;
        }
      }
      return [e1, e2, e3];
    },
    sortedSpeciesPhone() {
      var e = {};
      for (var i = 0; i < this.sortedTemp.length; i++) {
        e[this.sortedTemp[i]] = this.selectedSpecies[this.sortedTemp[i]];
      }
      return e;
    }
  },
  methods: {
    updateSpecies() {
      this.species = this.$route.params.species;
      this.lang = this.$route.params.lang;
    }
  },
  watch: {
    $route: "updateSpecies"
  },
  mounted() {
    this.$store.dispatch("getSpeciePhoto");
  }
};
</script>

<style scoped>
.test {
  width: 60%;
  margin: auto;
  position: relative;
  top: 85px;
  z-index: 1000 !important;
}
.test_phone {
  z-index: 10000 !important;
  width: 80%;
  margin: auto;
  position: relative;
  top: 100px;
}
.title {
  width: 100%;
  position: relative;
  top: 100px;
}
.photos_viewphotos {
  z-index: 0 !important;
  position: absolute;
  width: 100%;
  top: 8%;
}
.photos_viewphotos_div {
  position: absolute;
  width: 100%;
  top: 35%;
}
.main-div-phone {
  position: absolute;
  top: 55%;
  left: 0%;
  right: 0%;
}
.footer_photos {
  width: 100%;
  position: absolute;
  left: 0;
}
.columns {
  padding: 0;
  margin: 0;
}
.photo {
  transform: scale(1.05);
  transition: transform 0.5s;
  z-index: 10;
}
.photo:hover {
  transform: scale(1.15);
}
.view_photo {
  overflow: hidden;
}
.content {
  background-color: black;
}
.link {
  opacity: 0;
}
</style>